export const MERGE_COLUMN = 'columnTypes/MERGE_COLUMN';
export const MOVE_COLUMN = 'columnTypes/MOVE_COLUMN';
export const SPLIT_COLUMN = 'columnTypes/SPLIT_COLUMN';
export const UPDATE_COLUMN_SIZING = 'columnTypes/UPDATE_COLUMN_SIZING';
